import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportItemProductionService extends GenericService {
    constructor() {
        super('/reports/item_production', axiosInstance);
    }
}

export default new ReportItemProductionService(); 